import { useField } from '@unform/core';
import React, {
  InputHTMLAttributes,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { IconBaseProps } from 'react-icons';
import { FiAlertTriangle, FiEye, FiEyeOff } from 'react-icons/fi';

import { colors } from '../../styles/tokens';
import {
  Container,
  ContainerError,
  ContainerInput,
  Input,
  Label,
  ToggleVisibilityButton,
} from './styles';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  inputLabel?: string;
  icon?: React.ComponentType<IconBaseProps>;
  style?: any;
}

const InputLogin: React.FC<inputProps> = ({
  name,
  icon: Icon,
  inputLabel,
  style,
  type,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const isPassword = type === 'password';

  const { defaultValue, fieldName, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  return (
    <Container>
      <Label>{inputLabel}</Label>
      <ContainerInput isErrored={!!error} isFocused={isFocused}>
        {Icon && (
          <Icon
            size={20}
            color={colors.onSurfaceVariant}
            style={{ marginRight: 12 }}
          />
        )}
        <Input
          ref={inputRef}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          defaultValue={defaultValue}
          autoCapitalize="none"
          {...rest}
          type={isPassword && isPasswordVisible ? 'text' : type}
        />
        {isPassword && (
          <ToggleVisibilityButton
            type="button"
            tabIndex={-1}
            onClick={() => setIsPasswordVisible(visible => !visible)}
          >
            {isPasswordVisible ? (
              <FiEyeOff size={18} color={colors.onSurfaceVariant} />
            ) : (
              <FiEye size={18} color={colors.onSurfaceVariant} />
            )}
          </ToggleVisibilityButton>
        )}
      </ContainerInput>
      {!!error && (
        <ContainerError>
          <FiAlertTriangle size={15} color={colors.error} />
          <span>{error}</span>
        </ContainerError>
      )}
    </Container>
  );
};

export { InputLogin };
